/*! DEFAULT JS */

var AkronMuni = {
	header: null,
	heightToFixHeader: 0,
	fixedHeaderClass: "header-fixed-position",
	init: function() {
		AkronMuni.header = $("#layout-header");
		AkronMuni.heightToFixHeader = $("#header-top").height();

		AkronMuni.onScroll();
		$(window).scroll(AkronMuni.onScroll);

		AkronMuni.setupMobileNav();

		$("#navbar-search-link").click(AkronMuni.onSearchLinkClicked);
		$("#navbar-search-query-input").blur(AkronMuni.onSearchInputBlur);
	},
	// Hide other list items when nav dropdown is opened for mobile view
	setupMobileNav: function() {
		var listItems = $("#main-navbar-navbar-nav").children("li");

		listItems.each(function() {
			var setupListenerListItem = $(this);

			setupListenerListItem.on('show.bs.dropdown', function() {
				listItems.not(setupListenerListItem).each(function () {
					$(this).addClass("hidden");
				});
			});

			setupListenerListItem.on('hide.bs.dropdown', function() {
				listItems.not(setupListenerListItem).each(function () {
					$(this).removeClass("hidden");
				});
			});
		});
	},
	isInMobileView: function() {
		return $("#navbar-toggle-button").is(":visible");
	},
	onScroll: function(e) {
		if (!AkronMuni.isInMobileView())
		{
			if (AkronMuni.header.hasClass(AkronMuni.fixedHeaderClass))
			{
				if (document.body.scrollTop <= AkronMuni.heightToFixHeader)
				{
					AkronMuni.header.removeClass(AkronMuni.fixedHeaderClass);
				}
			}
			else if (document.body.scrollTop > AkronMuni.heightToFixHeader)
			{
				AkronMuni.header.addClass(AkronMuni.fixedHeaderClass);
			}
		}
	},
	onSearchLinkClicked: function(e) {
		e.preventDefault();

		$("#navbar-search-link").addClass("hidden");
		$("#navbar-search-form").removeClass("hidden");
		$("#navbar-search-query-input").focus();
	},
	onSearchInputBlur: function (e) {
		if (AkronMuni.isInMobileView())
		{
			// Don't hide on blur for mobile viewports
			return;
		}

		$("#navbar-search-form").addClass("hidden");
		$("#navbar-search-link").removeClass("hidden");
	}
};

$(function() {
	AkronMuni.init();
});
